import { useCallback, useEffect, useState } from "react";
import Portal from "../portal/Portal";
import styles from "./infoHint.module.css";

// A small "?" that shows `text` the moment it's hovered or focused (no
// browser-tooltip delay). The bubble is rendered in a portal at fixed
// coordinates so scrolling containers and cards can't clip it.
const InfoHint = ({ text, label = "توضيح" }) => {
  const [bubble, setBubble] = useState(null); // { top, left, below }

  const show = useCallback((event) => {
    const rect = event.currentTarget.getBoundingClientRect();
    const below = rect.top < 120;
    setBubble({
      top: below ? rect.bottom + 8 : rect.top - 8,
      left: rect.left + rect.width / 2,
      below,
    });
  }, []);
  const hide = useCallback(() => setBubble(null), []);

  // A fixed bubble would drift away from its icon on scroll.
  useEffect(() => {
    if (!bubble) return undefined;
    window.addEventListener("scroll", hide, true);
    return () => window.removeEventListener("scroll", hide, true);
  }, [bubble, hide]);

  return (
    <>
      <button
        type="button"
        className={styles.trigger}
        aria-label={label}
        onMouseEnter={show}
        onMouseLeave={hide}
        onFocus={show}
        onBlur={hide}
        onKeyDown={(event) => event.key === "Escape" && hide()}
      >
        ?
      </button>
      {bubble && (
        <Portal>
          <div
            role="tooltip"
            dir="rtl"
            className={`${styles.bubble} ${bubble.below ? styles.below : ""}`}
            style={{ top: bubble.top, left: bubble.left }}
          >
            {text}
          </div>
        </Portal>
      )}
    </>
  );
};

export default InfoHint;
